import {get, post} from '../index'
export default {
  getCasePicList (querys) {
    return get('/casepic/admin/list', querys)
  },

  setCasePic (querys) {
    return post('/casepic/admin/edit', querys)
  },

  getTemplateList (querys) {
    return get('/casepic/admin/templateList', querys)
  },

  setFirstLogin (querys) {
    return post('/casepic/admin/setFirstLogin', querys)
  },

  setTemplateContent (querys) {
    return post('/casepic/admin/setTemplateContent', querys)
  },

  creatQrcode () {
    return post('/casepic/admin/createQrCode')
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/casepic.js